import type { ReactElement, ReactNode } from 'react';
import type { MyBlogDto } from '@gr/core/accounts/workspaces/dto';
import { Link, useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { Card } from '../../../../ui-kit/Card/Card';
import { EmptyState } from '../../../../ui-kit/EmptyState/EmptyState';
import styles from './BlogList.module.scss';

export interface BlogListProps {
  blogs: readonly MyBlogDto[];
  /** Действие пустого списка — создать первый блог. */
  emptyAction?: ReactNode;
}

/** WS-UC-2: блоги пользователя с его ролью в каждом. */
export function BlogList({ blogs, emptyAction }: BlogListProps): ReactElement {
  const { t } = useT();
  if (blogs.length === 0) return <EmptyState title={t('workspaces.blogs.empty')} text={t('workspaces.blogs.emptyText')} action={emptyAction} />;
  return (
    <ul className={styles.grid}>
      {blogs.map((blog) => (
        <li key={blog.id}>
          <Card title={blog.name} actions={<Badge tone="accent">{t(`workspaces.roles.${blog.role}`)}</Badge>}>
            <div className="u-stack">
              {blog.description ? <p className="u-muted">{blog.description}</p> : null}
              <p className="u-muted u-small">{blog.timezone}</p>
              <Link to="posts" params={{ blogId: blog.id }}>
                {t('workspaces.blogs.open')}
              </Link>
            </div>
          </Card>
        </li>
      ))}
    </ul>
  );
}
